
export enum BusinessInfoType {
    C = 113,
    L = 114,
    O = 115,
    T = 116
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/business-info-type.enum.ts